/* tslint:disable */
require('./accounts')
require('./action')
require('./admin')
require('./adminrole')
require('./adminset')
require('./analytics')
require('./android')
require('./api')
require('./application')
require('./booth')
require('./building')
require('./charge')
require('./course')
require('./customer')
require('./dashboard')
require('./download')
require('./example')
require('./exit')
require('./eye-open')
require('./eye')
require('./form')
require('./home')
require('./human')
require('./icon_lesson')
require('./in')
require('./ios')
require('./iphones')
require('./link')
require('./logout')
require('./logs')
require('./management')
require('./nested')
require('./news')
require('./notification')
require('./password')
require('./permission')
require('./portal')
require('./promotion')
require('./rateLimit')
require('./report')
require('./schedule')
require('./search-user')
require('./setting')
require('./sms')
require('./system')
require('./table')
require('./teach')
require('./terms')
require('./text')
require('./transaction')
require('./tree')
require('./user')
require('./users')
require('./vendor')
require('./version')
require('./video')
require('./wallet')
require('./whatsapp')
